module.exports = __webpack_public_path__ + "static/0222-ec9c61988f643eee199715f29267a1fa.svg";